import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  logotype: {
    [theme.breakpoints.down('xs')]: {
      display: 'flex',
    },
    align: "center",
  },
  appBar: {
    width: '100vw',
    minHeight:'64px',
    display:'flex',
    justifyContent:'center',
    width: '100%',
    margin:'auto',
    zIndex: theme.zIndex.drawer + 1,
    paddingTop: `var(--safe-area-inset-top)`,
    paddingLeft: `var(--safe-area-inset-left)`,
    paddingRight: `var(--safe-area-inset-right)`,
    transition: theme.transitions.create(['margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  hide: {
    display: 'none',
  },
  grow: {
    flexGrow: 1,
  },
  headerMenu: {
    marginTop: theme.spacing(7),
  },
  headerMenuList: {
    display: 'flex',
    flexDirection: 'column',
  },
  headerMenuItem: {
    '&:hover, &:focus': {
      backgroundColor: theme.palette.primary.main,
      color: 'white',
    },
  },
  headerMenuButton: {
    marginLeft: theme.spacing(2),
    padding: theme.spacing(0.5),
  },
  headerMenuButtonCollapse: {
    marginRight: theme.spacing(2),
  },
  headerIcon: {
    fontSize: 28,
    color: 'rgba(255, 255, 255, 0.35)',
  },
  headerIconCollapse: {
    color: 'white',
  },

  profileMenu: {
    minWidth: 130,
  },
  profileMenuUser: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(2),
  },
  profileMenuItem: {
    color: theme.palette.text.hint,
  },
  profileMenuIcon: {
    marginRight: theme.spacing(2),
    color: theme.palette.text.hint,
  },
}));